import { Button, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { useEffect } from "react";

type ConfirmLeaveChangesModalProps = {
  onConfirm: VoidFunction;
  onCancel: VoidFunction;
  /** Discard in-progress edits when the user chooses to leave. */
  revertAll: VoidFunction;
};

/**
 * "Unsaved changes" prompt shown by a NavigationBlocker on the Finish Schedule admin pages. Opens
 * itself on mount and closes on unmount; the parent renders it only while a navigation is blocked.
 */
export function ConfirmLeaveChangesModal(props: ConfirmLeaveChangesModalProps) {
  const { onConfirm, onCancel, revertAll } = props;
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    openModal({
      content: (
        <>
          <ModalHeader>You Have Unsaved Changes</ModalHeader>
          <ModalBody>
            <p>You have unsaved changes. Save or discard your changes before leaving this page.</p>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="tertiary"
              label="Continue Editing"
              onClick={() => {
                closeModal();
                onCancel();
              }}
            />
            <Button
              label="Leave"
              variant="primary"
              onClick={() => {
                revertAll();
                onConfirm();
                closeModal();
              }}
            />
          </ModalFooter>
        </>
      ),
    });
    return () => closeModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}
